import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    gnsGsiClientUrl: `https://accounts.google.com/gsi/client`,
    gnsSwgUrl: `https://news.google.com/swg/js/v1/swg.js`,
    gnsSwgGaaUrl: `https://news.google.com/swg/js/v1/swg-gaa.js`,
  }) as const) satisfies ConfigFn

export default config
